import { useContext, useMemo } from "react";
import { CommonComponentContext } from "../utils/CommonComponentContext";
import { useTranslation } from "react-i18next";

export default function useConfigStatuses() {
    const { t } = useTranslation();
    const commonContext = useContext(CommonComponentContext);
    return useMemo(() => commonContext.configStatuses(t), [t, commonContext]);
}